import React from "react";

import { useRecipe } from "@/customHooks/useRecipe";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { RecipesResults } from "@/components/blocks/global/recipes-results/RecipesResults";
import { SectionTitle } from "@/components/elements/section-title/SectionTitle";
import { Container, useMediaQuery, useTheme } from "@mui/material";

export const RecipesSection = (): JSX.Element => {
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));
  const { t } = useTranslation("homepage");
  const router = useRouter();
  const { useGetRecipes } = useRecipe();
  const searchParams = {
    page_size: isGreaterThanTablet ? 8 : 4,
    lang: router.locale,
    ordering: "latest"
  };
  const useQueryResult = useGetRecipes(searchParams);

  return (
    <Container aria-label="recipe">
      <SectionTitle mt={5} mb={2.5} sx={{ textTransform: "none" }}>
        {t("recipes.title")}
      </SectionTitle>

      <RecipesResults
        useQueryResult={useQueryResult}
        pageSize={isGreaterThanTablet ? 8 : 4}
      />
    </Container>
  );
};
